module.exports = __webpack_public_path__ + "img/fakeprofile.5cf5da13.svg";